const MetaList = require('module/user/meta_list')
const Interest = require('module/user/interest')

const log = require('log').create('interest_list') // eslint-disable-line

const InterestList = MetaList.extend({

    id: 'interests',

    model: Interest,

})

module.exports = InterestList
